var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPledgeGrade(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3558_9189)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 2,
    width: 20,
    height: 20,
    fill: "url(#pattern0)",
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3558_9189",
    x: 0,
    y: 0,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.133333 0 0 0 0 0.321569 0 0 0 0 0.901961 0 0 0 0.29 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3558_9189"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3558_9189",
    result: "shape"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_3558_9189",
    transform: "scale(0.025)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_3558_9189",
    width: 40,
    height: 40,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAAXNSR0IArs4c6QAABoJJREFUWEftl2tsVEUUx/9zn7ul7wdPC9JSCEKACD6IohERiagfMBAxRoxgTJoaDYFEBGWNgiJghAjh1QgoYCKoIU2MSALysC2KRREo1BIehbb0Sbe73bv3MWbu3dvdbe92t60fiGGSm7ube87Mb/5zzpkZgju8kTucD3cB+7tC/38FZy6pG3Bo3WBff5WK5d9nBUvP0/sNAWUL32sQCQHG5kmBwZko5aAVfrEku/K/Au414Pla+gwhKFF1kHmLG00OSikYJHtnplJMGCVAFrmSTG/tCx7PuGB/YBMGrGqgz+kUB4MqYFCgaFUrGps1UGqAEM58d23j8yiGZEtNlBqzNy3NLu8LaEKAVxopbQ8CmmHBnasysGprc9R4FiDrjnbjGJhJMWa4ALfMf57lTV/q8RAtUdi4gHPnUn7lBmgMznw0YME7t0zV7OV1gnIC4HlgUgGlWWnuJj9pG1O8ODd6lg5OcQHfXNs4Y+H8rJ8ZXG0jsHmfD8Ggjht1SpRiLP7itWFDXLh8rR2prg5wHJCcJOlDRG/6t5vHtfc5i5dt9R+YMM49Z9MeL7wR3RTkC2ht1dDcqqPdFzSTJFZjMKkpAhqaFDORXKICkTcgCoDLJZWd3D58ap8B5yxrN6prDMfhn5+VAo4AJ055UTDShcwMAUYoV1TNgBKk0FTg0C8NneMznVm8proC4DmAFwh+35Ufc3pxl/jBRbepojibzZqeDFEMf7teo8Lr1zDxPrcJylTdvb82KkQtQIokKQCBo6aKKQP4ZUe3jPzEScUeAQvXN+WePCNeiyU/U9Ap9FpaNdQ1BFFx9rajKwPkoCLJpUHkAVGWjPLi4XyvAYvWNq89/pewxMkxM13AIw+5u31iy8Yay9i939UjqEbXRyNiRgMktsyWihluMuLwtvxuYvSo4Iseb/2FajrQCXD2jBRwXeZsw9n2t5pU/HTE2m2cmsgFIItWskiypJXuGC52tesR8PFCL/X6QpJ08Zz9VFJUSe4Kx8wlCSjeWxvlaW2LBLaSyXIAHLFUnPxoq7TtjSlqpEOPgJNeaaMc6R4aKckcpk11dfbjBMdKC0uSU394caO+I2RrDRdpr/jbzA1I4IGUJK7o2La8TQkBFq5pnFN63nWAOBy6pz4gISNd6DaY3TGDY4296xs0VFZZ5wW7mNvqqUEFEs9qKAXPERzaOLSbYDEVLFznv1h2lo7uGhMcIXh2lhsOZ4NOKBuOqXLkREdnKDBA9nQmiuYFx1FzieUkblrJmqEnEo7Blz7waVVXCQ/K4sUAAwPRzcFmz0h2DPpI5ZjBlWsGbtap0PRwJhuhSk51P0A18JwBWZaVknU54ZiJ6D2mgq+t9lNfALh8PdpEloEnH4vuy2SPMGOgTL1jpWy/tpoNyRTUDQM89ZkhwMoM0qS0Hz1ZbU6zjgn4+urm3YR3v1xRGR2EI0fwGDs6uhrYytlLy7a/vytVtN4OKxcJyNF2UznWREGoPLg2Z6zjkoSOI7G+oeizAK1vIbhSEx5o5nQZAh+eV1c41pkkAMfKgma82XWZqcZ+s7fEdYBAA89zKFk3qMdK0uPHtzYopYSQh09W6OYSMuNZM8LL2zXmLEWA3yp0KEEGRGGwE26omb+pDwQUAm9A4MiuHz4d+GpMheIp6PmSurx+tePiVQ5NzewQTPH0dBdCZ1UzhrpnOVB+WuvM1EhIVdPhFgMATDh8vyY77mElrsHy7UaNQcmwo6cU5N8roGCUVbgj4SQRyBsE5OYAh8spTl8woOvhcmLXP46y2ykFT3RkJZP5xe/nfNOTeuxbXMAVW2k+EfHPr2cUTJ0iQ5KtDB2WDUweBXrwOEh1DSBbdRt2RbnVrJuQPE/Md1ANwC1aBZvnBX3/qrSQR8+IcQGZ++q9lPo7gPFjgHOXgJY2QKexZ8cgfR3s0S1oncWcD1S3/g9K9t+zZUXujXjqJaQgM1q1S5mgQfqz6bZ19jTvbqHYN+M+4jrCfrOHJZXXb0FqhgKRU8HDgCwJNV+vTM1NBC5hQGb48T6q1zWCi3U30ixxOpt9om7zUciScTPFTXfCUDZueDu5PlG4XgF+9BVd3OLFejXOjZYAhiTSG6JIPFINdno8pPuNvheECcWg3d/yHZT6FRZT4REkF0BVekJTg4syJsrVnicSv5QnwtkrwA93021eP+bxHDakyNjz7gJyKZFB+mPTK8D+DNRX37uAfVXO9rvjFfwXk4m4R33Tv8QAAAAASUVORK5CYII="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPledgeGrade);
export default __webpack_public_path__ + "static/media/Pledge-grade.4630888b64c5128f2fe6964e8eae2122.svg";
export { ForwardRef as ReactComponent };